/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getOrganization = /* GraphQL */ `
  query GetOrganization($id: ID!) {
    getOrganization(id: $id) {
      id
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOrganizations = /* GraphQL */ `
  query ListOrganizations(
    $filter: ModelOrganizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFccOutlet = /* GraphQL */ `
  query GetFccOutlet($id: String!) {
    getFccOutlet(id: $id) {
      id
      name
      url
      order
      sortName
      sortOrder
      __typename
    }
  }
`;
export const listFccOutlets = /* GraphQL */ `
  query ListFccOutlets(
    $filter: TableFccOutletFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFccOutlets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        url
        order
        sortName
        sortOrder
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const queryFccOutletsByListFccOutletsSortByOrder = /* GraphQL */ `
  query QueryFccOutletsByListFccOutletsSortByOrder(
    $sortOrder: String!
    $first: Int
    $after: String
  ) {
    queryFccOutletsByListFccOutletsSortByOrder(
      sortOrder: $sortOrder
      first: $first
      after: $after
    ) {
      items {
        id
        name
        url
        order
        sortName
        sortOrder
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const queryFccOutletsByListFccOutletsSortByName = /* GraphQL */ `
  query QueryFccOutletsByListFccOutletsSortByName(
    $sortName: String!
    $first: Int
    $after: String
  ) {
    queryFccOutletsByListFccOutletsSortByName(
      sortName: $sortName
      first: $first
      after: $after
    ) {
      items {
        id
        name
        url
        order
        sortName
        sortOrder
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFccCategory = /* GraphQL */ `
  query GetFccCategory($id: String!) {
    getFccCategory(id: $id) {
      id
      name
      articles {
        id
        title
        url
        author
        summary
        content
        contentHtml
        publishedAt
        status
        outletName
        categoryName
        sentiment
        sortOrder
        sortCreatedAt
        orgName
        order
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      order
      sortOrder
      sortName
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listFccCategories = /* GraphQL */ `
  query ListFccCategories(
    $filter: TableFccCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFccCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        order
        sortOrder
        sortName
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const queryFccCategoriesByListFccCategoriesSortByName = /* GraphQL */ `
  query QueryFccCategoriesByListFccCategoriesSortByName(
    $sortName: String!
    $first: Int
    $after: String
  ) {
    queryFccCategoriesByListFccCategoriesSortByName(
      sortName: $sortName
      first: $first
      after: $after
    ) {
      items {
        id
        name
        order
        sortOrder
        sortName
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const queryFccCategoriesByListFccCategoriesSortByOrder = /* GraphQL */ `
  query QueryFccCategoriesByListFccCategoriesSortByOrder(
    $sortOrder: String!
    $first: Int
    $after: String
  ) {
    queryFccCategoriesByListFccCategoriesSortByOrder(
      sortOrder: $sortOrder
      first: $first
      after: $after
    ) {
      items {
        id
        name
        order
        sortOrder
        sortName
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFccReport = /* GraphQL */ `
  query GetFccReport($id: String!) {
    getFccReport(id: $id) {
      id
      title
      sendyUrl
      pdfUrl
      wordUrl
      articles {
        id
        title
        url
        author
        summary
        content
        contentHtml
        publishedAt
        status
        outletName
        categoryName
        sentiment
        sortOrder
        sortCreatedAt
        orgName
        order
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      reportDate
      publishedAt
      status
      sortCreatedAt
      sortPublishedAt
      orgName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listFccReports = /* GraphQL */ `
  query ListFccReports(
    $filter: TableFccReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFccReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        sendyUrl
        pdfUrl
        wordUrl
        reportDate
        publishedAt
        status
        sortCreatedAt
        sortPublishedAt
        orgName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const queryFccReportsByListFccReportsSortByPublishedAt = /* GraphQL */ `
  query QueryFccReportsByListFccReportsSortByPublishedAt(
    $sortPublishedAt: ActiveType!
    $first: Int
    $after: String
  ) {
    queryFccReportsByListFccReportsSortByPublishedAt(
      sortPublishedAt: $sortPublishedAt
      first: $first
      after: $after
    ) {
      items {
        id
        title
        sendyUrl
        pdfUrl
        wordUrl
        reportDate
        publishedAt
        status
        sortCreatedAt
        sortPublishedAt
        orgName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const queryFccReportsByListFccReportsSortByCreatedAt = /* GraphQL */ `
  query QueryFccReportsByListFccReportsSortByCreatedAt(
    $sortCreatedAt: ActiveType!
    $first: Int
    $after: String
  ) {
    queryFccReportsByListFccReportsSortByCreatedAt(
      sortCreatedAt: $sortCreatedAt
      first: $first
      after: $after
    ) {
      items {
        id
        title
        sendyUrl
        pdfUrl
        wordUrl
        reportDate
        publishedAt
        status
        sortCreatedAt
        sortPublishedAt
        orgName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFccArticle = /* GraphQL */ `
  query GetFccArticle($id: String!) {
    getFccArticle(id: $id) {
      id
      title
      reports {
        id
        title
        sendyUrl
        pdfUrl
        wordUrl
        reportDate
        publishedAt
        status
        sortCreatedAt
        sortPublishedAt
        orgName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categories {
        id
        name
        order
        sortOrder
        sortName
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      url
      author
      summary
      content
      contentHtml
      publishedAt
      status
      outletName
      categoryName
      sentiment
      sortOrder
      sortCreatedAt
      orgName
      order
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listFccArticles = /* GraphQL */ `
  query ListFccArticles(
    $filter: TableFccArticleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFccArticles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        url
        author
        summary
        content
        contentHtml
        publishedAt
        status
        outletName
        categoryName
        sentiment
        sortOrder
        sortCreatedAt
        orgName
        order
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const queryFccArticlesByListFccArticlesSortByCreatedAt = /* GraphQL */ `
  query QueryFccArticlesByListFccArticlesSortByCreatedAt(
    $sortCreatedAt: String!
    $filter: TableFccArticleFilterInput
    $first: Int
    $after: String
  ) {
    queryFccArticlesByListFccArticlesSortByCreatedAt(
      sortCreatedAt: $sortCreatedAt
      filter: $filter
      first: $first
      after: $after
    ) {
      items {
        id
        title
        url
        author
        summary
        content
        contentHtml
        publishedAt
        status
        outletName
        categoryName
        sentiment
        sortOrder
        sortCreatedAt
        orgName
        order
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const queryFccArticlesByListFccArticlesSortByOrder = /* GraphQL */ `
  query QueryFccArticlesByListFccArticlesSortByOrder(
    $sortOrder: ActiveType!
    $first: Int
    $after: String
  ) {
    queryFccArticlesByListFccArticlesSortByOrder(
      sortOrder: $sortOrder
      first: $first
      after: $after
    ) {
      items {
        id
        title
        url
        author
        summary
        content
        contentHtml
        publishedAt
        status
        outletName
        categoryName
        sentiment
        sortOrder
        sortCreatedAt
        orgName
        order
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFccArticleReport = /* GraphQL */ `
  query GetFccArticleReport($id: String!) {
    getFccArticleReport(id: $id) {
      id
      fccArticleId
      fccReportId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listFccArticleReports = /* GraphQL */ `
  query ListFccArticleReports(
    $filter: TableFccArticleReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFccArticleReports(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fccArticleId
        fccReportId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const queryFccArticleReportsByByFccReport = /* GraphQL */ `
  query QueryFccArticleReportsByByFccReport(
    $fccReportId: String!
    $first: Int
    $after: String
  ) {
    queryFccArticleReportsByByFccReport(
      fccReportId: $fccReportId
      first: $first
      after: $after
    ) {
      items {
        id
        fccArticleId
        fccReportId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const queryFccArticleReportsByByFccArticle = /* GraphQL */ `
  query QueryFccArticleReportsByByFccArticle(
    $fccArticleId: String!
    $first: Int
    $after: String
  ) {
    queryFccArticleReportsByByFccArticle(
      fccArticleId: $fccArticleId
      first: $first
      after: $after
    ) {
      items {
        id
        fccArticleId
        fccReportId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFccArticleCategory = /* GraphQL */ `
  query GetFccArticleCategory($id: String!) {
    getFccArticleCategory(id: $id) {
      id
      fccArticleId
      fccCategoryId
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listFccArticleCategories = /* GraphQL */ `
  query ListFccArticleCategories(
    $filter: TableFccArticleCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFccArticleCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fccArticleId
        fccCategoryId
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const queryFccArticleCategoriesByByFccArticle = /* GraphQL */ `
  query QueryFccArticleCategoriesByByFccArticle(
    $fccArticleId: String!
    $first: Int
    $after: String
  ) {
    queryFccArticleCategoriesByByFccArticle(
      fccArticleId: $fccArticleId
      first: $first
      after: $after
    ) {
      items {
        id
        fccArticleId
        fccCategoryId
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const queryFccArticleCategoriesByByFccCategory = /* GraphQL */ `
  query QueryFccArticleCategoriesByByFccCategory(
    $fccCategoryId: String!
    $first: Int
    $after: String
  ) {
    queryFccArticleCategoriesByByFccCategory(
      fccCategoryId: $fccCategoryId
      first: $first
      after: $after
    ) {
      items {
        id
        fccArticleId
        fccCategoryId
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
